import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-right: 24px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 100%;
  padding: 16px 0 16px;
  gap: 4px;
`;

export const BillingWrapper = styled.div`
  padding-top: 24px;
`;
